import { createMtListenerMiddleware } from "@/lib/storage/create-mt-listener-middleware"
import { RootState } from "@/lib/storage/redux-store"
import embeddedSlice from "./embedded-slice"
import tripSlice from "./trip-slice"
import { userSlice } from "./user-slice"

/**
 * Middleware that resets trip and chat state when navigating between embedded views.
 * This ensures state doesn't leak between views (e.g., currentTripRef staying set
 * after navigating away from trip view).
 *
 * Important: For this to work correctly, thunks must call setView BEFORE initializing
 * view-specific state. This ensures the middleware sees the correct previous view type.
 */
const embeddedViewSyncMiddleware = createMtListenerMiddleware<RootState>(
  "embedded-view-sync-middleware"
)

embeddedViewSyncMiddleware.startListening({
  actionCreator: embeddedSlice.actions.setView,
  effect: (action, listenerApi) => {
    const previousView = listenerApi.getOriginalState().embeddedSlice.view
    const newView = action.payload

    // Reset trip state when navigating away from trip view
    if (previousView.type === "trip" && newView.type !== "trip") {
      listenerApi.dispatch(tripSlice.actions.reset())
    }

    // Reset chat state when navigating away from chat view
    if (previousView.type === "chat" && newView.type !== "chat") {
      listenerApi.dispatch(userSlice.actions.resetChat())
    }
  },
})

export { embeddedViewSyncMiddleware }
